export class Alert {
    type: AlertType;
    message: string;
}

export enum AlertType {
    Success,
    Success2,
    Error,
    Info,
    Warning,
    Information
}
